import { render, staticRenderFns } from "./RfqDetail.vue?vue&type=template&id=73aa3954"
import script from "./RfqDetail.vue?vue&type=script&lang=js"
export * from "./RfqDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports